module.exports = __webpack_public_path__ + "img/ABISYSCS4.82682ed7.jpg";